import Flags from "./Flags";
import type { FlagProps } from "./Flags.d";

export { Flags };
export type { FlagProps };
